import { notification, Popover } from 'antd'
import { FC, useContext, useRef } from 'react'
import useFormInstance from 'antd/es/form/hooks/useFormInstance'
import { EditableCellCtx } from '../../../../../../components/editable-cell/editable-cell'
import MaterialTypesGrouped from '../../../../../../components/form-items/material-types-grouped/material-types-grouped'
import { useSingleActivePopover } from '../../../../../../hooks/use-single-active-popover'
import PopoverFooter from '../../../../../../components/popover-footer/popover-footer'

const MAIN_TYPE = ['material_type', 'set'] as const
const ADDITIONAL_TYPES = ['additional_material_types', 'set'] as const
const MAIN_WIDTH = ['material', 'set'] as const
const ADDITIONAL_WIDTHS = ['additional_materials', 'set'] as const

const ACTIVE_CALCULATION_POPOVER_EVENT = 'calculation-popover-active'

const MaterialTypesWrapper: FC = () => {
    const ctx = useContext(EditableCellCtx)
    const form = useFormInstance()
    const { open, setOpen, handleOpenChange } = useSingleActivePopover({
        eventName: ACTIVE_CALCULATION_POPOVER_EVENT,
        onClose: ctx.onCancel,
    })

    const readTypes = () => ({
        main: form.getFieldValue(MAIN_TYPE) as string | undefined,
        additional: (form.getFieldValue(ADDITIONAL_TYPES) ?? []) as string[],
    })

    const initialTypesRef = useRef(readTypes())

    const onPopoverOpenChange = (nextOpen: boolean) => {
        if (nextOpen) {
            initialTypesRef.current = readTypes()
        }
        handleOpenChange(nextOpen)
    }

    const onSave = () => {
        const { main, additional } = readTypes()
        const initial = initialTypesRef.current
        let widthsReset = false

        if (main !== initial.main) {
            form.setFieldValue(MAIN_WIDTH, undefined)
            widthsReset = true
        }

        if (
            [...additional].sort().join() !==
            [...initial.additional].sort().join()
        ) {
            form.setFieldValue(ADDITIONAL_WIDTHS, [])
            widthsReset = true
        }

        if (widthsReset) {
            notification.warning({
                message: 'Корректировки ширин сброшены',
                description: 'Изменён тип материала — укажите ширины заново.',
            })
        }

        ctx.onBlur()
        setOpen(false)
    }

    const onCancel = () => {
        ctx.onCancel()
        setOpen(false)
    }

    return (
        <Popover
            placement={'bottomLeft'}
            arrow={false}
            mouseLeaveDelay={0.2}
            trigger='click'
            content={
                <>
                    <div style={{ width: '500px' }}>
                        <MaterialTypesGrouped
                            name={MAIN_TYPE}
                            autoFocus
                            defaultOpen
                            rules={[]}
                            label={'Основной материал'}
                        />
                        <MaterialTypesGrouped
                            name={ADDITIONAL_TYPES}
                            mode={'multiple'}
                            rules={[]}
                            label={'Доп. материалы'}
                        />
                    </div>
                    <PopoverFooter onCancel={onCancel} onSave={onSave} />
                </>
            }
            open={open}
            onOpenChange={onPopoverOpenChange}
        >
            <div style={{ height: '100%', width: '1px' }}></div>
        </Popover>
    )
}

export default MaterialTypesWrapper
